import loadable from '@loadable/component'

export const MediaContact = loadable(() => import('./MediaContact'))
export const MediaContacts = loadable(() => import('./MediaContacts'))

export type { MediaContactProps } from './MediaContact'
export type { MediaContactsProps } from './MediaContacts'
